import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import { fetchContacts, selectContact } from '../../actions'
import ContactsTabs from './ContactsTabs'
import ExportContacts from './ExportContacts'
import ImportContacts from './ImportContacts'
import Loading from '../Loading'

import { Button } from 'antd'

class Contacts extends Component {
  componentDidMount = () => {
    const { match: { params }, fetchContacts } = this.props

    fetchContacts(params.projectId)
  }

  // shouldComponentUpdate (nextProps, nextState) {
  //   console.log(nextProps, nextState)
  //   return true
  // }

  render () {
    // console.log('RENDER: Contacts')

    const { loading, selectContact, contacts } = this.props

    if (loading.fetchContacts || !contacts) return <Loading />

    return (
      <div style={{ borderTop: '1px solid #e8e8e8' }}>

        <div style={{ margin: '20px 0 40px' }}>
          <span style={{ marginRight: 30 }}>
            <Button icon='plus' onClick={() => selectContact('create')}>
              Add contact
            </Button>
          </span>

          <span style={{ marginRight: 30 }}>
            <ImportContacts />
          </span>

          <span>
            <ExportContacts />
          </span>
        </div>

        <ContactsTabs key={Date.now()} />

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading,
  contacts: state.contacts
})

const mapDispatchToProps = {
  fetchContacts,
  selectContact
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Contacts))



// WEBPACK FOOTER //
// ./src/components/Contacts/Contacts.js